import { getVendorList } from "../../../actions/vendor-management.action";
import { addSubcontractorsAction } from "../../../slice/project-detail";
import { addSubcontractorsAction as addProjectSummarySubcontractors } from "../../../slice/project-summary";

export const getSubcontractorsData = async ({ type, dispatch }) => {
    let subcontractors = [];
    await dispatch(getVendorList(type)).then((vendors) => {
        vendors.forEach((vendor) => {
            subcontractors.push({ key: vendor.businessName, value: vendor.id });
        });

        dispatch(addSubcontractorsAction(subcontractors))
        dispatch(addProjectSummarySubcontractors(subcontractors))
    });
    return subcontractors;
};